import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/auth.css';

const ResetPassword = () => {
  const { token } = useParams();
  const { resetPassword } = useAuth();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const navigate = useNavigate();

  // Redirigir si no hay token
  useEffect(() => {
    if (!token) {
      navigate('/forgot-password');
    }
  }, [token, navigate]);

  // Validar contraseña
  const validatePassword = () => {
    const errors = {};

    if (password.length < 8) {
      errors.password = 'La contraseña debe tener al menos 8 caracteres';
    }

    if (!/[A-Z]/.test(password)) {
      errors.password = 'La contraseña debe contener al menos una letra mayúscula';
    }

    if (!/[0-9]/.test(password)) {
      errors.password = 'La contraseña debe contener al menos un número';
    }

    if (password !== confirmPassword) {
      errors.confirmPassword = 'Las contraseñas no coinciden';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validar contraseña
    if (!validatePassword()) {
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await resetPassword(token, password);
      setSuccess(true);

      // Limpiar campos
      setPassword('');
      setConfirmPassword('');
    } catch (error) {
      console.error('Error al restablecer la contraseña:', error);
      setError(
        error.message ||
          'Error al restablecer la contraseña. Por favor, solicita un nuevo enlace de recuperación.',
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>Restablecer Contraseña</h2>
        </div>
        <div className="auth-body">
          {error && <div className="alert alert-error">{error}</div>}

          {success ? (
            <div className="success-message">
              <div className="success-icon">
                <span className="material-icons">check_circle</span>
              </div>
              <h3>¡Contraseña Restablecida!</h3>
              <p>
                Tu contraseña ha sido restablecida correctamente. Ahora puedes iniciar sesión con tu
                nueva contraseña.
              </p>
              <div className="auth-actions">
                <Link to="/login" className="btn btn-primary btn-block">
                  Ir al Inicio de Sesión
                </Link>
              </div>
            </div>
          ) : (
            <>
              <p className="text-center">Ingresa tu nueva contraseña para restablecer tu cuenta.</p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="password">Nueva Contraseña</label>
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Ingresa tu nueva contraseña"
                    required
                  />
                  {validationErrors.password && (
                    <div className="form-error">{validationErrors.password}</div>
                  )}
                  <div className="password-requirements">
                    <p>La contraseña debe:</p>
                    <ul>
                      <li className={password.length >= 8 ? 'valid' : 'invalid'}>
                        Tener al menos 8 caracteres
                      </li>
                      <li className={/[A-Z]/.test(password) ? 'valid' : 'invalid'}>
                        Contener al menos una letra mayúscula
                      </li>
                      <li className={/[0-9]/.test(password) ? 'valid' : 'invalid'}>
                        Contener al menos un número
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="confirmPassword">Confirmar Contraseña</label>
                  <input
                    type="password"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirma tu nueva contraseña"
                    required
                  />
                  {validationErrors.confirmPassword && (
                    <div className="form-error">{validationErrors.confirmPassword}</div>
                  )}
                </div>
                <div className="auth-actions">
                  <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                    {loading ? 'Restableciendo...' : 'Restablecer Contraseña'}
                  </button>
                  <Link to="/login" className="btn btn-link btn-block">
                    Volver al Inicio de Sesión
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
